import {
  MrfiktivVehicleRegistrationViewModelGen,
  MrfiktivCreateVehicleRegistrationDtoGen,
  MrfiktivRegistrationDtoGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { VehicleTypes } from "@/store/enum/vehicle-types.enum";

class VehicleRegistrationBase implements MrfiktivVehicleRegistrationViewModelGen {
  firstname?: string;
  name?: string;
  street?: string;
  zipCode?: string;
  city?: string;
  huYear?: string;
  huMonth?: string;
  manufacturerNameCode?: string;
  manufacturerTypeCode?: string;
  driveTyp?: string;
  identificationnumber?: string;
  numberplate?: string;
  firstregistrationDay?: string;
  firstregistrationMonth?: string;
  firstregistrationYear?: string;
  manufacturerName?: string;
  manufacturerType?: string;
  vehicleClass?: VehicleTypes;

  constructor(registration?: MrfiktivCreateVehicleRegistrationDtoGen | MrfiktivRegistrationDtoGen) {
    this.firstname = registration?.firstname;
    this.name = registration?.name;
    this.street = registration?.street;
    this.zipCode = registration?.zipCode;
    this.city = registration?.city;
    this.huYear = registration?.huYear;
    this.huMonth = registration?.huMonth;
    this.manufacturerNameCode = registration?.manufacturerNameCode;
    this.manufacturerTypeCode = registration?.manufacturerTypeCode;
    this.driveTyp = registration?.driveTyp;
    this.identificationnumber = registration?.identificationnumber;
    this.numberplate = registration?.numberplate;
    this.firstregistrationDay = registration?.firstregistrationDay;
    this.firstregistrationMonth = registration?.firstregistrationMonth;
    this.firstregistrationYear = registration?.firstregistrationYear;
    this.manufacturerName = registration?.manufacturerName;
    this.manufacturerType = registration?.manufacturerType;
    this.vehicleClass = registration?.vehicleClass as VehicleTypes;
  }
}

type IVehicleRegistration = VehicleRegistrationBase;
const VehicleRegistration = VehicleRegistrationBase;

export { VehicleRegistration, IVehicleRegistration };
